import { Space } from "antd";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";

const ShowRosterFixtureAction = ({ fixtureId }: { fixtureId: string }) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const { customerId, sport, organizationId, seasonId } = useParams();

  const onClickHandler = () => {
    navigate(`/${customerId}/admin/${sport}/${organizationId}/seasons/${seasonId}/fixtures/${fixtureId}/roster`);
  };

  return (
    <Space style={{ columnGap: "5px" }} onClick={onClickHandler}>
      <i className="fas fa-users-gear mr-2" />
      {formatMessage({ id: "roster.fixture" })}
    </Space>
  );
};

export default ShowRosterFixtureAction;
